import React from 'react';
import './SideDrawer.css';

export type SideDrawerProps = {
  open: boolean;
  onClose: () => void;
  id: string;
  /** Optional accessible name for the drawer */
  ariaLabel?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  /** Extra class on the aside (e.g. flyout-open state) */
  className?: string;
};

/**
 * Shared right-side slide-out drawer used by the public site and dashboard.
 */
const SideDrawer: React.FC<SideDrawerProps> = ({
  open,
  onClose,
  id,
  ariaLabel = 'Menu',
  header,
  footer,
  children,
  className = '',
}) => (
  <>
    <div
      className={`side-drawer-backdrop ${open ? 'side-drawer-backdrop--open' : ''}`}
      onClick={onClose}
      aria-hidden={!open}
    />
    <aside
      id={id}
      className={['side-drawer', open ? 'side-drawer--open' : '', className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden={!open}
      aria-label={ariaLabel}
    >
      {header ? <div className="side-drawer__header">{header}</div> : null}
      <div className="side-drawer__body">{children}</div>
      {footer ? <div className="side-drawer__footer">{footer}</div> : null}
    </aside>
  </>
);

export default SideDrawer;
